import axios from 'axios';
import type {IResponse} from '@/common/scripts/types/utils';
import newsTemplate from './news-list-item.twig';

interface News {
    title: string;
    image: string;
    href: string;
    description?: string;
}

interface NewsResponse {
    news: News[];
    pagination: {
        page: string;
        pages: string;
    };
}

export const useNewsList = (wrapper: HTMLElement): void => {
    const url = wrapper.dataset['ajax'] || '/tests/news/index.php';
    const newsList = wrapper.querySelector<HTMLDivElement>('.j-news-list-container');
    const loadMoreBtn = wrapper.querySelector<HTMLButtonElement>('.j-news-list-load-more-btn');
    let nextPage: string = '2';

    if (!newsList || !loadMoreBtn) {
        return;
    }

    /**
     * Обработчик события клика на кнопку "Показать ещё".
     * Отправляет запрос на сервер для получения следующей страницы новостей.
     * Если достигнут конец списка, удаляет кнопку "Показать ещё" и слушатель события.
     */
    const handleLoadMore = (): void => {
        axios.post(url, {page: nextPage})
            .then((response: IResponse<NewsResponse>) => {
                const totalPages = Number(response.data.data.pagination.pages);

                if (totalPages <= Number(nextPage)) {
                    loadMoreBtn.removeEventListener('click', handleLoadMore);
                    loadMoreBtn.remove();
                } else {
                    nextPage = String(Number(nextPage) + 1);
                }

                response.data.data.news.forEach((item: News) => {
                    const newsHtml = newsTemplate({item});

                    newsList.insertAdjacentHTML('beforeend', newsHtml);
                });
            })
            .catch((error: unknown) => {
                console.error(`NewsList: Server error with status ${error}`);
            });
    };

    loadMoreBtn.addEventListener('click', handleLoadMore);
};
